import React from "react"
import { graphql } from "gatsby"
import { Intro, Block, Grid, Container, Seo, VideoTile } from "@components"
import Layout from "@layouts/layout"
import PropTypes from "prop-types"

const VideoList = ({ data, pageContext }) => {
  const { title = "Videos" } = pageContext
  const videos = data.videos.nodes

  const introConfig = {
    breadcrumbs: pageContext.breadcrumbs,
    title
  }

  return (
    <Layout>
      <Seo title={title} type={"website"} />
      <Block gutters>
        <Container>
          <Intro {...introConfig} />
        </Container>
      </Block>
      {videos.length > 0 && (
        <Block padding="bottom">
          <Grid moduleStyle={"3-up-grid"}>
            {videos.map(node => (
              <VideoTile
                key={`video-tile-${node.id}`}
                heading={node.videoTitle || node.title}
                path={`/videos/${node.slug}/`}
                thumbnailUrl={node.video?.thumbnailUrl}
                duration={node.duration}
              />
            ))}
          </Grid>
        </Block>
      )}
    </Layout>
  )
}

VideoList.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object
}

export default VideoList

export const query = graphql`
  query videoListPage($language: String!) {
    videos: allDatoCmsVideoPage(
      locale: $language
      sort: { meta: { createdAt: DESC } }
    ) {
      nodes {
        id
        title
        slug
        videoTitle
        duration
        video {
          thumbnailUrl
        }
      }
    }
  }
`
